module.exports = __webpack_public_path__ + "img/proxemics2.2e59529f.jpg";